"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalBrowserApi = void 0;
/**
 * ILC exposes some utility APIs globally at `window.ILC`. Here we provide convenience typings to use with typescript.
 *
 * @example
 * ```
 * import { GlobalBrowserApi } from 'ilc-sdk/app';
 *
 * GlobalBrowserApi.navigate('/mypath');
 * ```
 */
class GlobalBrowserApi {
    /**
     * Can be used for programmatic route change at simple apps.
     * Localization of the URL will be done automatically.
     */
    static navigate(urlWithoutLocale) {
        return window.ILC.navigate(urlWithoutLocale);
    }
    /**
     * Allows to fetch Parcel from the application and inject it with ILC specific configuration.
     *
     * @example
     * ```javascript
     * import Parcel from 'single-spa-react/parcel';
     *
     * <Parcel
     * config={() => ILC.importParcelFromApp('@portal/people', 'person')}
     * wrapWith="div"
     * prop1="value1"
     * />
     * ```
     */
    static importParcelFromApp(appName, parcelName) {
        return window.ILC.importParcelFromApp(appName, parcelName);
    }
}
exports.GlobalBrowserApi = GlobalBrowserApi;
/**
 * Will create and mount a single-spa parcel. See [details here](https://single-spa.js.org/docs/api/#mountrootparcel).
 *
 * @example
 * ```javascript
 * const parcel = ILC.mountRootParcel(() => ILC.importParcelFromApp('@portal/people', 'person'), {
 *  prop1: 'value1',
 *  domElement: document.getElementById('a-div'),
 * });
 * ```
 */
GlobalBrowserApi.mountRootParcel = (parcelConfig, parcelProps) => {
    return window.ILC.mountRootParcel(parcelConfig, parcelProps);
};
/**
 * Will return names of all registered shared libraries in ILC-Registry
 *
 * @example
 * ```javascript
 * const sharedLibNames = await ILC.getAllSharedLibNames();
 * ```
 */
GlobalBrowserApi.getAllSharedLibNames = () => {
    return window.ILC.getAllSharedLibNames();
};
